import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { queryClient } from "@/lib/queryClient";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";
import { ToastContainer } from "@/components/common/Toast";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import TripsPage from "@/pages/TripsPage";
import PlanPage from "@/pages/PlanPage";
import SharePage from "@/pages/SharePage";
import PlannerPreviewPage from "@/pages/PlannerPreviewPage";
import LoginPage from "@/pages/auth/LoginPage";
import MagicLinkPage from "@/pages/auth/MagicLinkPage";

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col relative overflow-hidden">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-28 right-[-8%] h-[34rem] w-[34rem] rounded-full bg-accent/20 blur-[130px]" />
            <div className="absolute top-1/3 left-[-8%] h-[28rem] w-[28rem] rounded-full bg-electric/12 blur-[120px]" />
            <div className="absolute bottom-[-12rem] right-1/4 h-[30rem] w-[30rem] rounded-full bg-warm/18 blur-[120px]" />
            <div className="absolute inset-0 lux-grid opacity-[0.16]" />
          </div>

          <Routes>
            <Route
              path="/plan/:id"
              element={
                <ProtectedRoute>
                  <PlanPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <>
                  <Header />
                  <main className="relative z-10 flex-1 page-fade">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/planner-preview" element={<PlannerPreviewPage />} />
                      <Route
                        path="/trips"
                        element={
                          <ProtectedRoute>
                            <TripsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="/shared/:token" element={<SharePage />} />
                      <Route path="/auth/login" element={<LoginPage />} />
                      <Route path="/auth/magic-link" element={<MagicLinkPage />} />
                      <Route
                        path="*"
                        element={
                          <div className="mx-auto mt-20 w-fit rounded-2xl frost-card px-8 py-5 text-center text-ink-light">
                            Page not found
                          </div>
                        }
                      />
                    </Routes>
                  </main>
                  <Footer />
                </>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
      <ToastContainer />
    </ErrorBoundary>
  </QueryClientProvider>
);

export default App;
